import { adminUsers } from '@ooh/contracts';
import type { QueryClient } from '@tanstack/react-query';
import { apiQueryKey } from '../../data/use-api-suspense-query';

export function invalidateUserQueries(queryClient: QueryClient): Promise<unknown> {
  return Promise.all(
    [adminUsers.listUsers, adminUsers.getUser, adminUsers.listUserOverrides].map((def) =>
      queryClient.invalidateQueries({ queryKey: apiQueryKey(def) }),
    ),
  );
}
